export const REPLACE_CAROUSEL_DATA ="REPLACE_CAROUSEL_DATA";
// export const FILTER_SERVICES_EXCLUISVE ="FILTER_SERVICES_EXCLUISVE";
// export const FILTER_SERVICES_DISCOUNT = "FILTER_SERVICES_DISCOUNT";


// WEBPACK FOOTER //
// ./src/actions/acttionsTypes.js